import styles from './index.scss'
import { NavBar, Space, Popup, SafeArea, Toast } from 'antd-mobile'
import goTo from '@/libs/functions/goTo'
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { SvgBackIcon } from '@/libs/components/Icon/svgIcon'
import classnames from 'classnames'

import backIco from './back-ico.png'
import homeIcon from './icon_home.png'
import customerIcon from './icon_customer.png'
import personalIco from './ico_personal.png'
import { history, useModel } from 'umi'
import getChannelBridgeApi, {
  historyBackWFallback,
} from '@/libs/functions/appAdapter'
import { getStorage } from '@/libs/functions/onStorage'
import { getUrlParam, getValue } from '@/libs/functions/getValue'
import useCategorySet from '../../hooks/useCategorySet'
import { useIntl } from 'umi'
import useLang, { useModuleLang } from '@/libs/hooks/useLang'
import {
  createBodyThemeOwner,
  normalizeThemeConfig,
  releaseBodyTheme,
  ThemeConfig,
  updateBodyTheme,
} from './themeConfig'

export type { ThemeConfig, ThemeConfigValue } from './themeConfig'

export type LayoutProps = {
  title?: string
  children: React.ReactNode
  onBack?: () => void
  onBeforeBack?: () => void
  backIconStyle?: React.CSSProperties
  navBar?: React.ReactNode
  backArrow?: boolean
  showHomeBtn?: boolean
  showCustomServiceBtn?: boolean
  rightHandle?: boolean
  rightExtraNode?: React.ReactNode
  customServiceTels?: {
    name: string
    tel: string
    enable: boolean
  }[]
  onHomeBtnClick?: () => void
  style?: { [key: string]: any }
  navBarStyle?: React.CSSProperties
  headerExtra?: string | React.ReactElement
  forceBackThirdApp?: boolean
  backIcon?: string
  onScroll?: Function
  navClassName?: any
  themeConfig?: ThemeConfig
  skipOPPOFix?: boolean
  forceHideNavBar?: boolean
}

export default function Layout(props: LayoutProps) {
  const intl = useIntl()
  const [promptT] = useModuleLang(['prompt_util'])

  const {
    title = '',
    backArrow = true,
    children,
    onBack,
    navBar,
    rightHandle = true,
    // 首页
    showHomeBtn = false,
    // 客服
    showCustomServiceBtn = false,
    customServiceTels = [],
    onHomeBtnClick = () => goTo('/personal'),
    style = {},
    headerExtra = <></>,
    // 强制返回第三方app
    forceBackThirdApp = false,
    rightExtraNode = <></>,
    backIcon = backIco,
    themeConfig,
    forceHideNavBar = false,
  } = props

  const themeOwnerRef = useRef<number | null>(null)
  if (themeOwnerRef.current === null) {
    themeOwnerRef.current = createBodyThemeOwner()
  }
  const normalizedThemeConfig = normalizeThemeConfig(themeConfig)
  const normalizedThemeConfigRef = useRef(normalizedThemeConfig)
  normalizedThemeConfigRef.current = normalizedThemeConfig

  useLayoutEffect(() => {
    updateBodyTheme(
      themeOwnerRef.current as number,
      normalizedThemeConfigRef.current,
    )
  }, [normalizedThemeConfig.signature])

  useLayoutEffect(() => {
    const ownerId = themeOwnerRef.current as number
    return () => releaseBodyTheme(ownerId)
  }, [])

  const { qiankunGlobalState } =
    useModel('@@qiankunStateFromMaster') || useModel('@@qiankunStateForSlave')
  const [customerPopupVisible, setCustomerPopupVisible] =
    useState<boolean>(false)

  // 从url 带参数设置隐藏h5头部导航栏
  const hideWebviewNavBar = getStorage('hideWebviewNavBar') == 1
  const channel =
    qiankunGlobalState.channel ||
    getStorage('channel') ||
    getUrlParam('channel')
  const {
    hideNavBar,
    goBackWebview,
    hideLayoutNavBar,
    setNavBar,
    initApi,
    destory,
  } = getChannelBridgeApi(channel)
  const pathname = window.location.hash.replace('#', '')
  const { categorySetting } = useCategorySet('TENANT', getValue('tenantCode'))
  const h5Setting = categorySetting.h5Setting || {}

  useEffect(() => {
    initApi && initApi()
    return () => {
      destory && destory()
    }
  }, [])

  useEffect(() => {
    if (hideNavBar) hideNavBar()
  }, [hideNavBar])

  const rightHandleDom = rightHandle ? (
    <div>
      <Space style={{ '--gap': '12px' }}>
        {showHomeBtn && (
          <img
            onClick={onHomeBtnClick}
            className={styles.homeIcon}
            src={homeIcon}
          />
        )}
        {showCustomServiceBtn && customServiceTels.length > 0 && (
          <img
            onClick={() => setCustomerPopupVisible(true)}
            className={styles.customerIcon}
            src={customerIcon}
          />
        )}
      </Space>
    </div>
  ) : (
    rightExtraNode
  )

  useEffect(() => {
    // For seo search and miniprogram webview's title display.
    setTimeout(() => {
      let titleEl = document.getElementsByTagName('title')[0]
      titleEl.innerHTML = title
      const iframe = document.createElement('iframe')
      iframe.style.visibility = 'hidden'
      iframe.style.width = '1px'
      iframe.style.height = '1px'
      iframe.onload = function () {
        setTimeout(() => {
          document.body.removeChild(iframe)
        }, 0)
      }
      document.body.appendChild(iframe)
    }, 0)

    setTimeout(() => {
      setNavBar && setNavBar(title)
    }, 100)
  }, [title])

  const _hideLayoutNavBar =
    forceHideNavBar || hideLayoutNavBar() || hideWebviewNavBar

  const backArrowIcon = backArrow ? (
    h5Setting.headerNavBackIcon ? (
      <img
        src={h5Setting.headerNavBackIcon}
        style={{
          width: 44,
          height: 44,
          display: 'inline',
          marginLeft: -10,
          pointerEvents: 'auto',
          ...props?.backIconStyle,
        }}
      />
    ) : (
      <SvgBackIcon
        style={{ ...props?.backIconStyle }}
        color={props?.backIconStyle?.color}
      />
    )
  ) : null
  const isShowNavBar = h5Setting.headerNavStyleType === 'float'

  return (
    <div className={styles.layout} id="layout" style={style}>
      {!_hideLayoutNavBar && (
        <>
          {navBar ? (
            navBar
          ) : (
            <NavBar
              backArrow={backArrowIcon}
              onBack={() => {
                if (props.onBeforeBack) props.onBeforeBack()
                if (onBack) {
                  console.log('onBack>>')
                  // 回退失败则返回上一个app webview
                  return historyBackWFallback(onBack, goBackWebview)
                }

                if (forceBackThirdApp) {
                  console.log('forceBackThirdApp>>')
                  goBackWebview()
                } else {
                  console.log('forceBackThirdApp goTo(-1)>>')
                  // 回退失败则返回上一个app webview
                  return historyBackWFallback(() => goTo(-1), goBackWebview)
                }
              }}
              right={
                <div style={{ pointerEvents: 'auto' }}>{rightHandleDom}</div>
              }
              // className={styles.navBar}
              className={classnames([
                styles.navBar,
                props?.navClassName,
                styles[props?.navOutClassName],
              ])}
              style={
                isShowNavBar
                  ? {
                      ...props?.navBarStyle,
                      pointerEvents: 'none',
                      background: 'transparent',
                    }
                  : props?.navBarStyle
              }
            >
              {isShowNavBar ? '' : title}
            </NavBar>
          )}
        </>
      )}
      {headerExtra}
      <div
        id="render-container"
        className={`${styles.container} ${
          _hideLayoutNavBar ? styles.hideLayoutNavBar : ''
        }`}
        onScroll={props?.onScroll}
        style={isShowNavBar ? { top: 0 } : {}}
      >
        {children}
      </div>
      <Popup
        visible={customerPopupVisible}
        onMaskClick={() => {
          setCustomerPopupVisible(false)
        }}
        showCloseButton
        bodyStyle={{
          borderTopLeftRadius: '8px',
          borderTopRightRadius: '8px',
        }}
        onClose={() => setCustomerPopupVisible(false)}
      >
        <div className={styles.customerService}>
          <h3 className={styles.customerPopupTitle}>
            {promptT('contactCustomer', '联系客服')}
          </h3>
          {customServiceTels &&
            customServiceTels.length &&
            customServiceTels.map((item, index: number) => {
              return item.enable ? (
                <a
                  className={styles.customerPopupItem}
                  key={index}
                  href={`tel:${item.tel}`}
                >
                  {item.tel} ({item.name})
                </a>
              ) : (
                ''
              )
            })}
        </div>
      </Popup>
    </div>
  )
}
